export default {
    fleet: {
        name: 'Géolocalisation',
        handleRole: true,
        handleGroups: true,
        class: 'fleet',
        icon: 'FleetIcon'
    },
    park: {
        name: 'Gestion de parc',
        handleRole: true,
        handleGroups: true,
        class: 'park',
        icon: 'ParkIcon'
    },
    mission: {
        name: 'SuiviMissions',
        handleRole: true,
        handleGroups: false,
        class: 'mission',
        icon: 'MissionIcon'
    },
    beepiz: {
        name: 'Beepiz',
        handleRole: true,
        handleGroups: true,
        class: 'beepiz',
        icon: 'BeepizIcon'
    },
    bom: {
        name: 'Editeur BOM',
        handleRole: true,
        handleGroups: false,
        class: 'bom',
        icon: 'BomIcon'
    },
    vision: {
        name: 'SuiviVision',
        handleRole: true,
        handleGroups: false,
        class: 'vision',
        icon: 'VisionIcon'
    },
    api: {
        name: 'API',
        handleRole: true,
        handleGroups: false,
        class: 'api',
        icon: 'ApiIcon'
    },
    admin: {
        name: 'Manager',
        handleRole: true,
        handleGroups: false,
        class: 'admin',
        icon: 'AdminIcon'
    },

}






// WEBPACK FOOTER //
// ./src/services/universes.js